import ApprovePhotoModal from "./ApprovePhotoModal";

export default ApprovePhotoModal;
